export default "__VITE_ASSET__vVoBeZXU__"